import "./HeroNav.css";
import BoloLogo from "../assets/bli-logo.svg";

export default function HeroNav({ compact = false }) {
  return (
    <div className={`hero-nav ${compact ? "hero-nav--compact" : ""}`.trim()}>
      <a href="/" className="hero-nav__logo">
        <img src={BoloLogo} alt="BoloIndia" />
      </a>
    </div>
  );
}
